import { FC } from 'react'

import { cn } from '@/app/utils'
import { LogoCircleIcon } from '@/components/shared/icons'

type Props = {
  className?: string
}

const CommentsEmptyList: FC<Props> = ({ className }) => {
  return (
    <div className={cn('mt-24 flex flex-col items-center', className)}>
      <LogoCircleIcon className="mb-54 h-80 w-80" />

      <p
        data-testid="chat-empty-welcome-id"
        className="max-w-[600px] text-center font-bold text-24"
      >
        Мы рады вам помочь, наш сотрудник ответит на ваши вопросы как можно
        скорее
      </p>
    </div>
  )
}

export default CommentsEmptyList
